// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"1b7a7ccf","239":"0baa80c9","453":"4df3a008","455":"652f4627","977":"0f0db0ef"}[chunkId] + ".chunk.js";
};